import { Flex, Input, InputGroup, Text } from '@baont0209/pibridge_uikit_v20';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import ReactPaginate from 'react-paginate';
import { useTranslation } from 'contexts/Localization';
import { EditIcon, NextPagiIcon, PrevPagiIcon, SearchWalletIcon } from 'components/Pancake-uikit';
import { CheckWhiteListTable, CheckWhiteListV2 } from '../hooks/fetchData';
import { ImgWhiteList, TextHead, TextLink, TextTitle } from '../styles';

interface WhiteListProps {
    marginTop?: any;
}


const WhiteList = ({marginTop}: WhiteListProps) => {

    const { t } = useTranslation()
    const {isWhiteListTable} = CheckWhiteListTable()
    
    // We start with an empty list of items.
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);
    const itemsPerPage = 8;

     // search
     const [searchQuery, setSearchQuery] = useState('')
     const [searchTable, setSearchTable] = useState([]);

    const handleChangeSearchQuery = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(event.target.value)
    }
    useEffect(() => {
        function SearchItem () {
                // query === null
           if (searchQuery === ""){
            setSearchTable(isWhiteListTable)
           }
            else {
            const tmpTable = isWhiteListTable?.filter(item => (item.address.toLowerCase().includes(searchQuery.toLowerCase())));
            setSearchTable(tmpTable)
           }
        }
        if ( searchQuery || isWhiteListTable ) {
            SearchItem()
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery, isWhiteListTable])



    function ConverAddress(addressUser: any) {
        // eslint-disable-next-line react/destructuring-assignment
       
        const accountTablet = addressUser ? `${addressUser.substring(0, 12)}...${addressUser.substring(addressUser.length - 12)}` : null;
        const accountMobile =  addressUser ? `${addressUser.substring(0, 10)}...${addressUser.substring(addressUser.length - 10)}` : null;

        
        if (addressUser  && window.screen.width <= 600) {
            return (
                <TextLink>{accountMobile}</TextLink>
            )
        }
        if (window.screen.width <= 768) {
            return (
                <TextLink>{addressUser}</TextLink>
            )
        } 
        if (window.screen.width > 768) {
       
            return (
                <TextLink>{addressUser}</TextLink>
            )
        }
    }

    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;

        const tmpTable = searchTable?.filter(item => (item.available || item.minted))        

        setCurrentItems(tmpTable?.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(tmpTable?.length / itemsPerPage));
      }, [isWhiteListTable, itemOffset, itemsPerPage, searchTable]);




    const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % isWhiteListTable?.length;
    setItemOffset(newOffset);
    };

    
    const { whiteListTable } = CheckWhiteListV2(currentItems);
    
    return (
            <RowWhiteList marginTop={marginTop}>
                <Flex justifyContent='center' mb='20px'>
                <ImgWhiteList src='./images/ImgPi/pi-revolution.png'/>
                </Flex>
                <Flex justifyContent='center' mb='30px'>
                <TextTitle textTransform='uppercase'>WHITELISTED ADDRESSES</TextTitle>
                </Flex>

                <CustomInputGroup>
                    <WrapInputSearch> 
                        <CSInputSearch type='text' placeholder={t("Paste your wallet address to check eligibility")} onChange={handleChangeSearchQuery}/>
                        <SearchWalletIcon mr="10px"/>
                    </WrapInputSearch>
                </CustomInputGroup>
        
                <WrapWhiteList>
                    {whiteListTable && whiteListTable?.length !== 0 ?
                        <>
                         {whiteListTable?.map((item) => (
                            <Flex key={item.address} justifyContent='space-between'>
                                <TextWhitelistUser>{ConverAddress(item.address)}</TextWhitelistUser>
                                <TextLink>{item.available && !item.minted ? 'Eligible' : "Minted"}</TextLink>
                            </Flex>
                            ))
                        }
                        </>
                        :
                        <Flex justifyContent='center' width='100%'>
                            <Text>{t('Ineligible')}</Text>
                        </Flex>
                    }
                </WrapWhiteList>
                
                <CustomFlex>
                    <ReactPaginate
                      nextLabel={<PrevPagiIcon />}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      marginPagesDisplayed={1}
                      pageCount={pageCount}
                      previousLabel={<NextPagiIcon />}
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item page-arrow"
                      previousLinkClassName="page-link"
                      nextClassName="page-item page-arrow"
                      nextLinkClassName="page-link"
                      breakLabel="..."
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      containerClassName="pagination"
                      activeClassName="active"
                      renderOnZeroPageCount={null}
                    />
                </CustomFlex>
            </RowWhiteList>
    );
};

export default WhiteList;


// WhiteList
const RowWhiteList = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  margin-top: 60px;
  height: auto;
  @media screen and (min-width: 1900px) {
    height: auto;
    margin-top: 40px;
  }
`


const WrapWhiteList = styled(Flex)`
  flex-direction: column;
  gap: 25px;
  min-height: 350px;

  @media screen and (min-width: 1900px) {
    min-height: 400px;
  }
`

const TextWhitelistUser = styled(Text)`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 150%;
    color: #494949;
    div {
        @media screen and (min-width: 2000px) {
            font-size: 16px;
        }
    }

`

const CustomFlex = styled(Flex)`
    height: 60px;
    display: flex;
    justify-content: center;
    .pagination{
        display:flex;
        flex-direction: row;
        width:500px;
        justify-content: center;
        gap: 20px;
        align-items:center;
        /* margin-top: 30px; */
        @media screen and (max-width: 600px){
            width: 100%;
            gap: 5px;
        }
        *{
            list-style-type: none;
        }
    }
    .page-item{
        border: 1px solid #494949;
        width: 35px;
        height: 35px;

        @media screen and (max-width: 600px) {
            width: 28px;
            height: 33px;
        }
    }
    .page-link {
        background: transparent;
        border-radius:5px !important;
        color: #494949;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        &:focus {
            box-shadow:none !important;
        }
        &:hover{
            color: #494949 !important;
        }
    }
    .page-item.disabled .page-link{
        cursor: not-allowed! important;
        opacity: 0.7;
        pointer-events:none;
        color: #494949 !important;
        border: 1px solid #999999;
        background-color: rgb(233,234,235);
        border-color: rgb(233,234,235);
        box-shadow: none;
        color: rgb(189,194,196);
        cursor: not-allowed;
    }
    .page-item.active{
        color: red !important;
    }

    .page-item.active .page-link{
        color: red !important;
    }

    .page-arrow {
        font-size: 20px;
    }

`

const CustomInputGroup = styled(InputGroup)`
  width: 100%;
  display: flex;
  justify-content: center;
  border-radius:5px;
  margin-bottom: 30px;
  @media only screen and (max-width: 600px) {
  }

  @media screen and (min-width: 1900px) {
        margin-bottom: 50px;
    }
`

const WrapInputSearch = styled(Flex)`
    border: 1px solid #494949;
    height: 36px;
    width: 400px;
    @media screen and (max-width: 2000px) {
        width: 60%;
        height: 50px;
    }
    @media screen and (max-width: 600px) {
        width: 100%;
        height: 50px;
    }
`

const CSInputSearch = styled(Input)`
  background-color: transparent;
  color:#494949;
  font-size: 13px;
  border: none;
  height: 100%;
  &:focus:not(:disabled) {
    box-shadow: none;
  }
  &::placeholder {
    color: #494949;
  }
  @media screen and (min-width: 1900px) {
        font-size: 16px;
    }

  @media screen and (max-width: 400px) {
    font-size: 10px;
    &::placeholder {
        font-size: 12px;
    }
  }
  @media screen and (max-width: 320px) {
    font-size: 10px;
    &::placeholder {
        font-size: 11px;
    }
  }


`